import React, { ReactElement } from "react";
import portraits, { defaultPortrait } from "../assets";
import { GameState } from "../types";
import { Award } from "./awards";
import "./Awards.css";

/** The awards recap on the end screen (the ceremony before it has already named the winners). */
export default function Awards(props: { gameState: GameState; user: string; awards: Award[] }): ReactElement | null {
  const awards = props.awards;
  if (awards.length === 0) {
    return null;
  }
  return (
    <div className="go-history aw-section">
      <div className="go-history-title">AWARDS</div>
      <div className="aw-grid">
        {awards.map((a, i) => (
          <div key={a.id} className="aw-card" style={{ animationDelay: 0.4 + i * 0.12 + "s" }}>
            <div className="aw-icon" aria-hidden="true">
              {a.icon}
            </div>
            <div className="aw-body">
              <div className="aw-title">{a.title}</div>
              <div className="aw-winners">
                {a.winners.map((name) => {
                  const icon = props.gameState.icon[name];
                  const portrait = icon && icon !== defaultPortrait ? portraits[icon] : undefined;
                  return (
                    <span key={name} className={"aw-winner" + (name === props.user ? " aw-you" : "")}>
                      {portrait ? <img src={portrait} alt="" /> : <span className="aw-initial">{name.charAt(0)}</span>}
                      {name}
                      {name === props.user ? " (you)" : ""}
                    </span>
                  );
                })}
              </div>
              <div className="aw-stat">{a.stat}</div>
              <div className="aw-blurb">{a.blurb}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
